import React, { useState } from "react";
import styled from "styled-components";
import RemarkButton from "../remark/remarkButton";
import BasketIcon from "../../../../../../generic/icons/IconLib/BasketIcon";
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications";
import ChevronLeftIcon from "../../../../../../generic/icons/IconLib/ChevronLeftIcon";
import LayersIcon from "../../../../../../generic/icons/IconLib/LayersIcon";

// Styled Components
const Wrapper = styled.div`
    position: absolute;
    width: 6em;
    height: 10em;
    z-index: 2;
    right: 0;
    top: 15em;
    display: flex;
    transform: translateX(50%);
    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

const FlexContainer = styled.div`
    height: 100%;
    width: 50%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: space-around;
`;

const FlexItemContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    align-items: center;
    background: #80b3ae;
    font-size: 1.4em;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    
    svg {
        color: #fff;
        cursor: pointer;
    }
`;

const MoveButton = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5em;
    color: #297f76;
    cursor: pointer;
    
    svg {
        transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
`;

// Types and Interfaces
interface FloatContainerProps {
    setPresetWindow: (value: boolean) => void;
    customerId: string;
    filterGoodsValue: string | null;
    handleOpenRemarkModal: () => void;
    remarkButtonRef: React.RefObject<HTMLElement>;
    getPresetBrod: boolean;
    neededStatus: boolean;
    handleControllBasket: () => void;
}



// Component
const FloatContainer: React.FC<FloatContainerProps> = ({
    setPresetWindow, 
    customerId, 
    filterGoodsValue, 
    handleOpenRemarkModal,
    remarkButtonRef,
    getPresetBrod, 
    neededStatus,
    handleControllBasket
}) => {
    const [switcher, setSwitcher] = useState<boolean>(false)

    const handlePresetOpener = (): void => {
        if ((filterGoodsValue !== '101' && filterGoodsValue !== null && customerId !== '')) {
            setPresetWindow(true)
            setSwitcher(false)
        } else if (getPresetBrod && !neededStatus) {
            setPresetWindow(true);
            setSwitcher(false)
        } else {
            handleNotifications(`בחר לקוח/קבוצה להמשך`, {type: "error"})
        }
    };

    const handleSwitcherToggle = (): void => {
        setSwitcher(!switcher)
    };

    const positionToggle = switcher ? 'translateX(0)' : 'translateX(50%)';
    const buttonSwitcherToggle = switcher ? 'rotate(180deg)' : 'rotate(0)';

    return (
        <Wrapper style={{ transform: positionToggle }}>
            <FlexContainer>
                <MoveButton onClick={handleSwitcherToggle}>
                    <span
                        style={{ display: 'inline-flex', transform: buttonSwitcherToggle }}
                        aria-label="Toggle menu"
                    >
                        <ChevronLeftIcon />
                    </span>
                </MoveButton>
            </FlexContainer>
            
            <FlexContainer>
                <FlexItemContainer>
                    <span
                        onClick={handlePresetOpener}
                        style={{ display: 'inline-flex', cursor: 'pointer' }}
                        role="button"
                        tabIndex={0}
                        aria-label="Open preset window"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handlePresetOpener();
                            }
                        }}
                    >
                        <LayersIcon />
                    </span>
                    <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={handleControllBasket}><BasketIcon /></span>
                    <RemarkButton
                        handleOpenRemarkModal={handleOpenRemarkModal}
                    />
                </FlexItemContainer>
            </FlexContainer>
        </Wrapper>
    );
};

export default FloatContainer; 